import "./BasicInformation.html";
import "./BasicInformation.scss";
import "./EditFunctionalityTypeInformation/EditFunctionalityTypeInformationComponent";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import BasicInformationComponentController from "./BasicInformationComponentController";

export default class BasicInformationComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            equipmentFunctionalityType: "<",
        };
        this.controller = BasicInformationComponentController;
        this.templateUrl = "/App/Components/EquipmentFunctionalityType/BasicInformation/BasicInformation.html";
    }
}

module("mmManagePortal").component("irFunctionalityTypeDashboardBasicInformation", new BasicInformationComponent());
